module.exports = __webpack_public_path__ + "media/images/icons/country_flags/nl-874fbf1b360bed6592fce7601c7d6edb.svg";